




















































































































































































































































































































































































































































































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { i18n } from "@/resources/locales";
import { HELP_AND_SUPPORT } from "@/resources/constants/helpAndSupport";
@Component({
  name: "plan-warning-premium-component",
})
export default class PlanWarningPremiumComponent extends Vue {
  isCentered = false;
  get active() {
    return this.$store.getters["SystemStore/getShowModalPlanWarningPremium"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowModalPlanWarningPremiumAction", e);
  }
  onCancel() {
    this.active = false;
  }
  showBenefits() {
    this.isCentered = true;
  }
  hirePlan() {
    let subject = i18n.t("plans.hirePlan").toString();
    const mailtoLink = `mailto:${encodeURIComponent(HELP_AND_SUPPORT.EMAIL)}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailtoLink;
  }
}
